import { gql, useQuery, } from "@apollo/client";
import React, { createContext } from "react";
import { openingHoursQuery } from "../../data";
import parse from "../../data/opening-hours/parse";
export const query = (locale) => gql `{
  ${openingHoursQuery(locale)}
}`;
const defaultContext = {
    loading: false,
    error: false,
    openingHours: {},
};
export const OpeningHoursContext = createContext(defaultContext);
export const OpeningHoursConsumer = OpeningHoursContext.Consumer;
const OpeningHoursProvider = (props) => {
    let openingHoursData;
    let queryStatus = {
        loading: true,
        error: false,
    };
    if (props.openingHours) {
        queryStatus = {
            loading: false,
            error: false,
        };
        openingHoursData = props.openingHours;
    }
    else {
        if (!props.currentMarket) {
            throw new Error("Current market need to be defined for OpeningHoursProvider to query data");
        }
        // Create an empty apollo options object
        const apolloOptions = {};
        // Set custom client if available
        // Use client from context otherwise
        if (props.client) {
            apolloOptions.client = props.client;
        }
        // Set custom context if available
        if (props.queryContext) {
            apolloOptions.context = props.queryContext;
        }
        const { data, error, loading } = useQuery(query(props.currentMarket.cmsLocale), apolloOptions);
        openingHoursData = data;
        if (error) {
            queryStatus = {
                error: error.message,
                loading: false,
            };
        }
        else if (!loading) {
            queryStatus = {
                error: false,
                loading: false,
            };
        }
    }
    const context = {
        ...queryStatus,
        openingHours: openingHoursData ? parse(openingHoursData) : {},
    };
    return (React.createElement(OpeningHoursContext.Provider, { ...props, value: context }, props.children));
};
export default OpeningHoursProvider;
